import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IDocumentSettings } from '../purchases.interface';
@Injectable({
  providedIn: 'root'
})
export class DocumentSettingService {
  data$: BehaviorSubject<IDocumentSettings>;
  data: IDocumentSettings;

  constructor() {
    this.data = {} as IDocumentSettings;
    this.data$ = new BehaviorSubject(this.data);
  }

  getData$(): Observable<IDocumentSettings> {
    return this.data$.asObservable();
  }

  setData(data: IDocumentSettings) {
    this.data = {
      ...data
    };

    this.data$.next(this.data);
  }

  emptyData() {
    this.data = {} as IDocumentSettings;

    this.data$.next(this.data);
  }

  unsubscribeSubject() {
    this.data$.unsubscribe();
  }
}
